import { call, put } from 'redux-saga/effects';
import { requestSearch } from '../requests/search';
import { showAlert } from '../../slices/alerts';
import { safeErrorMessage } from '../../../utils/errorUtils';

export function* handleSearch(action) {
    try {
        const { query, type, from, limit, callback } = action.payload;
        const response = yield call(requestSearch, query, type, from, limit);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}
